import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import { Check, ChevronRight } from 'lucide-react';
import { ICON_SIZE } from '../../icons';
import './DropdownMenu.css';

/**
 * shadcn 模式的下拉菜单：Radix 出行为（定位、翻转、外点/Escape、方向键、
 * 子菜单、focus 归还），rds token 出面。面戴 .rds-popover（frame 只在它身上
 * 声明一次），本文件只管 item 层的版式与状态。
 */
export const DropdownMenu = DropdownMenuPrimitive.Root;
export const DropdownMenuTrigger = DropdownMenuPrimitive.Trigger;
export const DropdownMenuGroup = DropdownMenuPrimitive.Group;

export const DropdownMenuLabel = ({ className = '', ...props }) => (
  <DropdownMenuPrimitive.Label className={`rds-dropdown-menu__label ${className}`.trim()} {...props} />
);

export const DropdownMenuContent = ({ className = '', sideOffset = 4, collisionPadding = 12, ...props }) => (
  <DropdownMenuPrimitive.Portal>
    <DropdownMenuPrimitive.Content
      sideOffset={sideOffset}
      collisionPadding={collisionPadding}
      className={`rds-popover rds-dropdown-menu ${className}`.trim()}
      {...props}
    />
  </DropdownMenuPrimitive.Portal>
);

export const DropdownMenuItem = ({ className = '', ...props }) => (
  <DropdownMenuPrimitive.Item className={`rds-dropdown-menu__item ${className}`.trim()} {...props} />
);

export const DropdownMenuSeparator = ({ className = '', ...props }) => (
  <DropdownMenuPrimitive.Separator className={`rds-dropdown-menu__separator ${className}`.trim()} {...props} />
);

export const DropdownMenuSub = DropdownMenuPrimitive.Sub;

export const DropdownMenuSubTrigger = ({ className = '', children, ...props }) => (
  <DropdownMenuPrimitive.SubTrigger
    className={`rds-dropdown-menu__item rds-dropdown-menu__sub-trigger ${className}`.trim()}
    {...props}
  >
    {children}
    <ChevronRight size={ICON_SIZE.xs} className="rds-dropdown-menu__chevron" aria-hidden="true" />
  </DropdownMenuPrimitive.SubTrigger>
);

export const DropdownMenuSubContent = ({ className = '', sideOffset = 4, collisionPadding = 12, ...props }) => (
  <DropdownMenuPrimitive.Portal>
    <DropdownMenuPrimitive.SubContent
      sideOffset={sideOffset}
      collisionPadding={collisionPadding}
      className={`rds-popover rds-dropdown-menu ${className}`.trim()}
      {...props}
    />
  </DropdownMenuPrimitive.Portal>
);

export const DropdownMenuRadioGroup = DropdownMenuPrimitive.RadioGroup;

// 区别单选和多选：RadioItem 只用 selected 背景，勾选指示器只属于 CheckboxItem。
export const DropdownMenuRadioItem = ({ className = '', children, ...props }) => (
  <DropdownMenuPrimitive.RadioItem
    className={`rds-dropdown-menu__item rds-dropdown-menu__option-item ${className}`.trim()}
    {...props}
  >
    {children}
  </DropdownMenuPrimitive.RadioItem>
);

export const DropdownMenuCheckboxItem = ({ className = '', children, ...props }) => (
  <DropdownMenuPrimitive.CheckboxItem
    className={`rds-dropdown-menu__item rds-dropdown-menu__option-item ${className}`.trim()}
    {...props}
  >
    {children}
    <DropdownMenuPrimitive.ItemIndicator className="rds-dropdown-menu__indicator">
      <Check size={ICON_SIZE.xxs} aria-hidden="true" />
    </DropdownMenuPrimitive.ItemIndicator>
  </DropdownMenuPrimitive.CheckboxItem>
);
